//https://stackoverflow.com/questions/49923588/input-type-number-with-pattern-0-9-allows-letters-in-firefox/49923778
export const preventNonNumericInputVals = (
  evt: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  options?: { allowDecimal?: boolean },
) => {
  const charCode = typeof evt.which === "undefined" ? evt.keyCode : evt.which;
  const charStr = String.fromCharCode(charCode);
  const pattern = options?.allowDecimal ? /^[-0-9.]+$/ : /^[-0-9]+$/;

  if (!charStr.match(pattern)) {
    evt.preventDefault();
    return;
  }

  if (options?.allowDecimal && charStr === "." && evt.currentTarget.value.includes(".")) {
    evt.preventDefault();
  }
};
